import CircleIcon from "@mui/icons-material/Circle";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import { Box, Typography } from "@mui/material";
import { ResponsiveBar } from "@nivo/bar";
import React from "react";
import { useTranslation } from "react-i18next";

function Submittals({ size, isMock }) {
  const { t: tAnalytics } = useTranslation("analytics");

  // Define the new data for the bar chart
  const mockData = [
    {
      status: tAnalytics("onTime"),
      count: 4,
      color: "#F9DF3A",
    },
    {
      status: tAnalytics("delayed"),
      count: 2,
      color: "#F49898",
    },
    {
      status: tAnalytics("closed"),
      count: 8,
      color: "#CACACA",
    },
  ];

  // Use isMock if true, otherwise set data to null
  const data = isMock ? mockData : [];

  let content;
  switch (size) {
    case "sm":
      content = (
        <Box
          sx={{
            position: "relative",
            height: { xs: "85%", md: "85%", lg: "100%", xl: "105%" },
            width: "100%",
          }}
        >
          <ResponsiveBar
            data={data}
            keys={["count"]}
            indexBy="status"
            margin={{ top: 20, right: 0, bottom: 0, left: 0 }}
            padding={0.1} // Adjust padding for thicker bars
            groupMode="grouped"
            colors={({ data }) => data.color}
            borderRadius={8}
            borderColor={{
              from: "color",
              modifiers: [["darker", 1.6]],
            }}
            axisTop={null}
            axisRight={null}
            axisBottom={null}
            axisLeft={null}
            enableGridY={false}
            enableLabel={false}
            legends={[]} // Remove legends from the chart
            tooltip={({ id, value, indexValue }) => (
              <Box
                sx={{
                  padding: "8px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "16px",
                  background: "rgba(255, 255, 255, 0.80)",
                  boxShadow: "0px 4px 12px 0px rgba(46, 43, 43, 0.10)",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "12px",
                    fontStyle: "normal",
                    fontWeight: 500,
                    color: "#4B4B4B",
                  }}
                >
                  {value} {tAnalytics("submittals")}
                </Typography>
              </Box>
            )}
          />
          <Box
            sx={{
              height: "30%",
              width: "100%",
              display: "flex",
              flexWrap: { xs: "nowrap", lg: "wrap" },
              justifyContent: "flex-start",
              gap: "8px",
              padding: "8px",
              flexDirection: { xs: "column", lg: "row" },
            }}
          >
            {/* Custom Legends */}
            <Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
              <CircleIcon sx={{ color: "#F9DF3A", fontSize: "10px" }} />
              <Typography
                sx={{
                  fontSize: "11.5px",
                  fontStyle: "normal",
                  fontWeight: 500,
                  color: "#8E8E8E",
                }}
              >
                {tAnalytics("onTime")}
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
              <CircleIcon sx={{ color: "#F49898", fontSize: "10px" }} />
              <Typography
                sx={{
                  fontSize: "11.5px",
                  fontStyle: "normal",
                  fontWeight: 500,
                  color: "#8E8E8E",
                }}
              >
                {tAnalytics("delayed")}
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
              <CircleIcon sx={{ color: "#CACACA", fontSize: "10px" }} />
              <Typography
                sx={{
                  fontSize: "11.5px",
                  fontStyle: "normal",
                  fontWeight: 500,
                  color: "#8E8E8E",
                }}
              >
                {tAnalytics("closed")}
              </Typography>
            </Box>
          </Box>
        </Box>
      );
      break;
    case "md":
      content = <></>;
      break;
    case "lg":
      content = <></>;
      break;
    default:
      content = <></>;
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100%",
      }}
    >
      <Box sx={{ display: "flex", gap: "8px" }}>
        <ReceiptLongOutlinedIcon sx={{ color: "#44D5DA" }} />
        <Typography
          sx={{ fontSize: "16px", fontStyle: "normal", fontWeight: "500" }}
        >
          {tAnalytics("submittals")}
        </Typography>
      </Box>
      {content}
    </Box>
  );
}

export { Submittals };
